import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUserData = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  const query = useQuery({
    queryKey: ['userData'],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/me` });
      return result;
    },
    staleTime: 0,
    cacheTime: 0
  });

  return query;
};
